import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from 'tss-react/mui';

// First cell of a row in the call journal, recordings and voicemail lists:
// a round icon, a title, and an optional second line. New items are bold with
// a dot.

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  icon: {
    flexShrink: 0,
    width: 36,
    height: 36,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      fontSize: 19,
    },
  },
  tone_neutral: {
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.action.hover,
  },
  tone_brand: {
    color: theme.palette.tone.brand.main,
    backgroundColor: theme.palette.tone.brand.soft,
  },
  tone_success: {
    color: theme.palette.tone.success.main,
    backgroundColor: theme.palette.tone.success.soft,
  },
  tone_danger: {
    color: theme.palette.tone.danger.main,
    backgroundColor: theme.palette.tone.danger.soft,
  },
  tone_urgent: {
    color: theme.palette.tone.urgent.main,
    backgroundColor: theme.palette.tone.urgent.soft,
  },
  text: {
    minWidth: 0,
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 15,
    fontWeight: 500,
    lineHeight: 1.35,
    color: theme.palette.text.primary,
  },
  titleNew: {
    fontWeight: 700,
  },
  newDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    flexShrink: 0,
    backgroundColor: theme.palette.primary.light,
  },
  detail: {
    fontSize: 12.5,
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    fontVariantNumeric: "tabular-nums",
  },
  detailDanger: {
    color: theme.palette.tone.danger.main,
  },
  nowrap: {
    whiteSpace: "nowrap",
  },
}));

const ListParty = ({ icon, iconLabel, tone = "neutral", title, detail, detailDanger = false, isNew = false, wrap = false }) => {
  const { classes, cx } = useStyles();
  return (
    <div className={classes.root}>
      <span className={cx(classes.icon, classes[`tone_${tone}`])} title={iconLabel}>
        {icon}
      </span>
      <div className={classes.text}>
        <div className={cx(classes.title, isNew && classes.titleNew, !wrap && classes.nowrap)}>
          {title}
          {isNew && <span className={classes.newDot} title="New" />}
        </div>
        {detail ? (
          <div className={cx(classes.detail, detailDanger && classes.detailDanger, !wrap && classes.nowrap)}>
            {detail}
          </div>
        ) : null}
      </div>
    </div>
  );
};

ListParty.propTypes = {
  icon: PropTypes.node.isRequired,
  iconLabel: PropTypes.string,
  tone: PropTypes.oneOf(["neutral", "brand", "success", "danger", "urgent"]),
  title: PropTypes.node.isRequired,
  detail: PropTypes.node,
  detailDanger: PropTypes.bool,
  isNew: PropTypes.bool,
  wrap: PropTypes.bool,
};

export default ListParty;
